import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from '../../../shared/base.page';
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { UIService } from '../../../shared/services/UIService';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';  
declare var CKEDITOR: any; 

@Component({
    templateUrl: './emailtemplates.page.html' 
})

export class EmailTemplatesPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    @ViewChild("frmReset") frmReset: DxValidationGroupComponent; 
    //@ViewChild("myckeditor") ckeditor:any;
    items: any[] = [
        {
            title: "Add New Language",
            name: "addNewLang",
            icon: "icon-globe",
            showOnRow: true,
            class: "info",
        }
    ] 

    loadingVisible: boolean = false;
    popupLogVisible: boolean = false;
    popupEditVisible: boolean = false;
    log: string = null;
    editRow: any = {};
    countries: any[] = [];
    config:any={};
    
    constructor(public router: Router, serviceCaller: ServiceCaller, public uiService: UIService) {
        super(serviceCaller);
        this.config.uiColor= '#39b2d5';
        this.config.height='400px';
        this.config.forcePasteAsPlainText =true;
        this.config.allowedContent =true 
        this.config.docType = '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">';
        serviceCaller.get('/Country/List').then(c => {
            this.countries = c;
        });
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "addNewLang":
            {
                debugger
                let list = this.grid.instance.getSelectedRowKeys();
                if (list.length) {  
                    let param={FileName:e.data.FileName};
                    this.api.post("/EmailTemplate/Get",param).then((d) => {                         
                        this.editRow={
                            Code:"",
                            Body:d,
                            IsNew:true,
                            FileName:e.data.FileName
                        } 
                        this.popupEditVisible = true;
                        setTimeout(() => {
                            if(CKEDITOR.instances["option_text"])
                                CKEDITOR.instances["option_text"].destroy();
                            CKEDITOR.config.uiColor= '#39b2d5';
                            CKEDITOR.config.height='400px';
                            CKEDITOR.config.forcePasteAsPlainText =true;
                            CKEDITOR.config.allowedContent =true 
                            CKEDITOR.config.docType = '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">';
                            CKEDITOR.replace('option_text'); 
                            CKEDITOR.instances["option_text"].setData(d);
                        }, 200); 
                    }).catch(e => { }).then(c => {
                        this.loadingVisible = false;
                    }); 
                }
                break;
            }
        }
    }


    save() {
        if (this.frmReset.instance.validate().isValid) {
            this.loadingVisible = true; 
            this.editRow.Body=CKEDITOR.instances["option_text"].getData();
            this.api.post("/EmailTemplate/Save", this.editRow).then(() => {
                this.grid.instance.refresh();
                this.popupEditVisible = false;
            }).catch(e => { }).then(c => {
                this.loadingVisible = false;
            });
        }

    }

    cancel()
    {  
        this.popupEditVisible = false; 
    }


    onLangClick(fileName,code) {
        let param={FileName:fileName};  
        this.api.post("/EmailTemplate/Get",param).then((d) => {  
            this.editRow={
                Code:code,
                Body:d,
                IsNew:false,
                FileName:fileName
            }
            this.popupEditVisible = true;
            setTimeout(() => {
                if(CKEDITOR.instances["option_text"])
                    CKEDITOR.instances["option_text"].destroy();
                CKEDITOR.config.uiColor= '#39b2d5';
                CKEDITOR.config.height='400px';
                CKEDITOR.config.forcePasteAsPlainText =true;
                CKEDITOR.config.allowedContent =true 
                CKEDITOR.config.docType = '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.0 Transitional//EN">';
                CKEDITOR.replace('option_text'); 
                CKEDITOR.instances["option_text"].setData(d);
            }, 100); 
            
        }).catch(e => { }).then(c => {
            this.loadingVisible = false;
        });
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Settings/emailtemplates.page.ts